import { Controller } from "@hotwired/stimulus"

// Periodically triggers an update event for save status display
// Handles setInterval with proper cleanup on disconnect
export default class extends Controller {
  static values = { interval: { type: Number, default: 1000 } }

  connect() {
    this.startTimer()
  }

  disconnect() {
    this.stopTimer()
  }

  startTimer() {
    this.timer = setInterval(() => {
      this.dispatch("tick")
    }, this.intervalValue)
  }

  stopTimer() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }
}
